import { useFormContext } from "react-hook-form";
import { AlarmScheduleFormType, alarmScheduleUnits } from "./AlarmScheduleEditorUtils";
import FormInput from "../../../components/forms/form-input/FormInput";
import { useTranslation } from "react-i18next";
import { MenuItem, Stack } from "@mui/material";
import { useEffect } from "react";
import FormSelect from "../../../components/forms/form-select/FormSelect";


export type AlarmScheduleIntervalProps = {
    name: "duration" | "repeat";
    onChange?: () => void;
    disabled?: boolean;
};
export default function AlarmScheduleInterval({
    name,
    onChange,
    disabled
}: AlarmScheduleIntervalProps) {

    const { t } = useTranslation();
    
    const {
        watch
    //,   getValues
    ,   resetField
    //,   setValue
    ,   trigger
    } = useFormContext<AlarmScheduleFormType>();

    const [value] = watch([`${name}.value`]);

    useEffect(() => {

        if (value === null) {

            resetField(`${name}.value`, {keepDirty: false});
            trigger(`${name}.value`);
        }
    }, [
        name,
        value,
        resetField,
        trigger
    ]);

    return (

        <Stack direction='row'>
            <FormInput
                name={`${name}.value`}
                label={name === 'duration' ? t('alarmSchedule.duration') : t('alarmSchedule.repeatInterval')}
                numeric={true}
                decimals={0}
                sx={{
                    width: 1,
                    marginTop: 1,
                    marginBottom: 1,
                }}
                rules={{
                    required: {
                        value: true,
                        message: t('alarmSchedule.valueRequired')
                    },
                }}
                onChange={() => onChange && onChange()}
                disabled={disabled}
            />

            <FormSelect
                name={`${name}.unit`}
                label={t('alarmSchedule.unit')}
                sx={{ 
                    width: 1,
                    marginTop: 1,
                    marginLeft: 1
                }}
                onChange={() => onChange && onChange()}
                disabled={disabled}
            >
                {alarmScheduleUnits.map(o => (
                    <MenuItem key={o.Key} value={o.Key}>
                        {o.Value}
                    </MenuItem>
                ))}
                
            </FormSelect>

        </Stack>
    )
}
